import { useAuthStore } from '@/stores/authStore.js'
import { csrfFetch } from './csrf.js'


export async function sendLogin(email, password) {
    const response = await csrfFetch('/api/login', {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            'email': email,
            'password': password
        })
    });

    const auth = useAuthStore();
    if (response.status == 200) {
        var userdata = await response.json();
        await auth.setAuthenticated(true, email, password, userdata);
        return true;
    }
    else {
        auth.setAuthenticated(false, '', '', '');
    }
    return false;
};

export async function sendLogout() {
    console.log("logout")
    const response = await csrfFetch('/api/logout', {
        method: 'POST'
    });

    if (response.status == 200) {
        const auth = useAuthStore();
        auth.setAuthenticated(false, '', '', '');
        location.reload(); 
        return true;
    }
    return false;
};


export async function myfetch(route, body) {
    var response = await csrfFetch(route, body);
    const auth = useAuthStore();
    if (response.status == 401 && auth.email.length > 0) {
        if (await sendLogin(auth.email, auth.password)) {
            response = await csrfFetch(route, body);
        }
        else {
            location.reload();
        }

    }
    return response;
}